// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b272c1b6","239":"ea5f7e92","453":"dea9d465","455":"abbc8121"}[chunkId] + ".chunk.js";
};